import { render } from "./Dummy.vue?vue&type=template&id=9fc4de40"
const script = {}

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__